import SecondaryMenu from "../../components/layout/SecondaryMenu";
import Modal from "../../components/Modal";

import { MotifButton } from "@ey-xd/motif-react";

import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "../../assets/css/pages/new-activity.scss";
import { fetchCountriesData, postQuestion } from "../../services/api";
import { nanoid } from "../../globals";

import LabelsContext from "../../context/LabelsContext";
import Questions from "../../components/form/molecules/QuestionFields";
import InvalidModal from "../../components/InvalidModal";

const NewQuestion = () => {
  const [showModal, setShowModal] = useState(false);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const labels = useContext(LabelsContext);

  const [formData, setFormData] = useState({
    answers: [
      {
        answerText: "",
        correctAnswer: false,
      },
    ],
    icon: "",
    questionText: "",
    questionType: "RECYCLING",
  });

  //const handleFieldChange = (field, value) => {
  //setFormData((prev) => ({ ...prev, [field]: value }));
  //};
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCountriesData().then((data) => {
      const countries = Array.isArray(data)
        ? data.map((country) => ({
            value: country.countryName,
            label: country.countryName,
          }))
        : [];
      setCountryOptions(countries);
    });
  }, []);
  const handleFormSubmit = async () => {
    setisFormSubmited(true);
    if (isFormValid()) {
      setIsDisabledButton(true);
      const id = nanoid();
      const submitData = {
        ...formData,
        id,
      };
      await postQuestion(submitData);
      navigate("/sustainability/all-questions");
      setIsDisabledButton(false);
    } else {
      setShowInvalidModal(true);
      setIsDisabledButton(false);
    }
  };

  const isFormValid = () => {
    return Object.values(formData).every((field) => Boolean(field));
  };

  const [isFormSubmited, setisFormSubmited] = useState(false);
  const navigate = useNavigate();

  const openWarningModal = () => {
    setShowModal(true);
  };

  const closeWarningModal = () => {
    setShowModal(false);
  };
  const closeInvalidModal = () => {
    setShowInvalidModal(false);
  };
  const handleDiscardChanges = () => {
    document.body.style.overflow = "auto";
    setShowModal(false);
    navigate("/");
  };

  const handleNavigateHome = () => {
    navigate("/sustainability/all-questions");
  };

  return (
    <>
      <SecondaryMenu
        title={labels.console_create_questions}
        onNavigate={handleNavigateHome}
        editing={true}
        pageType="questions"
      />
      <section className="motif-col-lg-12 section-page">
        <Questions
          formData={formData}
          setFormData={setFormData}
          isFormSubmited={isFormSubmited}
          labels={labels}
          countryOptions={countryOptions}
          fieldVisibility={{
            questionText: true,
            answers: true,
            icon: true,
            country: true,
          }}
        />
        <div className="activity-buttons">
          <MotifButton
            variant="secondary"
            onClick={openWarningModal}
            className="activity-buttons-secondary"
          >
            {labels.console_cancel}
          </MotifButton>
          <MotifButton
            onClick={handleFormSubmit}
            className="activity-buttons-primary"
          >
            {labels.console_save}
          </MotifButton>
        </div>
      </section>
      <section className="motif-col-lg-5"></section>

      <Modal
        show={showModal}
        onClose={closeWarningModal}
        title={labels.console_unsavedChanges}
        body={labels.console_leavePage}
        primaryButtonText={labels.console_keepEditing}
        onPrimaryButtonClick={closeWarningModal}
        secondaryButtonText={labels.console_discardChanges}
        onSecondaryButtonClick={handleDiscardChanges}
        disabled={isDisabledButton}
      />
      <InvalidModal
        show={showInvalidModal}
        onClose={closeInvalidModal}
        title={labels.console_title_invalidForm}
        body={labels.console_body_invalidForm}
        primaryButtonText={labels.console_close}
        onPrimaryButtonClick={closeInvalidModal}
      />
    </>
  );
};

export default NewQuestion;
